import api from "./api";

export const versionService = {
    getChbVersion
};

function getChbVersion() {
    return api.get("/cable-health-broker/version");
}
